export const companyCategoryKeys = {
  all: () => ['company-categories'] as const,
  list: () => [...companyCategoryKeys.all(), 'list'] as const,
};
